import { render } from "./BlogListView.vue?vue&type=template&id=2d9bbca0&scoped=true"
import script from "./BlogListView.vue?vue&type=script&lang=js"
export * from "./BlogListView.vue?vue&type=script&lang=js"

import "./BlogListView.vue?vue&type=style&index=0&id=2d9bbca0&scoped=true&lang=css"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9bbca0"]])

export default __exports__